import axios from "./Interceptors";
import { TCF_URL } from "./URLs";

const fileHeaders = { "Content-Type": "multipart/form-data" }

const getAllFundraisers = async (payload) => {
    return await axios.post(TCF_URL.GET_ALL_FUNDRAISER_PAGES, payload);
}

const getFundraiserDetails = async (slug) => {
    return await axios.get(TCF_URL.GET_FUNDRAISER_DETAILS(slug))
}

const getEventId = async () => {
    return await axios.get(TCF_URL.GET_EVENT_ID)
}

const getCountryGoalRange = async (countryId) => {
    return await axios.get(TCF_URL.GET_COUNTRY_GOAL_RANGE(countryId))
}

const createFundraiserPage = async (payload) => {
    return await axios.post(TCF_URL.CREATE_FUNDRAISER_PAGE, payload, fileHeaders)
}

const updateFundraiserPage = async (pageId, payload) => {
    return await axios.post(TCF_URL.UPDATE_FUNDRAISER_PAGE(pageId), payload, fileHeaders)
}

const getCampaignsList = async () => {
    return await axios.get(TCF_URL.GET_ALL_CAMPAIGNS);
}

const getOccasions = async () => {
    return await axios.get(TCF_URL.GET_OCCASIONS);
}

const getFundraiserDefaultImage = async () => {
    return await axios.get(TCF_URL.GET_DEFAULT_IMAGE);
}

const createTeamMember = async (payload) => {
    return await axios.post(TCF_URL.CREATE_TEAM_MEMBER, payload)
}

const removeTeamMember = async (payload) => {
    return await axios.post(TCF_URL.REMOVE_TEAM_MEMBER, payload)
}

const getTeamMembers = async (id) => {
    return await axios.get(TCF_URL.GET_TEAM_MEMBERS(id))
}

const getTeamMembersWithPagination = async (id, status, limit, pageNo) => {
    return await axios.get(TCF_URL.GET_TEAM_MEMBERS_WITH_PAGINATION(id, status, limit, pageNo))
}

const getTeamMembersCount = async (id, status) => {
    return await axios.get(TCF_URL.TEAM_MEMBERS_COUNT(id, status))
}

const getTeamMemberDetails = async (id, pageID) => {
    return await axios.get(TCF_URL.TEAM_MEMBER_DETAILS(id, pageID))
}

const getPageDonors = async (id, limit, pageNo) => {
    return await axios.get(TCF_URL.PAGE_DONORS(id, limit, pageNo))
}

const getPageRecentDonations = async (id, limit, pageNo) => {
    return await axios.get(TCF_URL.PAGE_RECENT_DONATIONS(id, limit, pageNo))
}

const getPageHighestDonations = async (id, limit, pageNo) => {
    return await axios.get(TCF_URL.PAGE_HIGHEST_DONATIONS(id, limit, pageNo))
}

const getPageDonationsCount = async (id) => {
    return await axios.get(TCF_URL.DONATIONS_COUNT(id))
}

const getFundraisersCount = async () => {
    return await axios.get(TCF_URL.FUNDRAISERS_COUNT)
}

const validateFundraiserTitle = async (payload) => {
    return await axios.post(TCF_URL.VALIDATE_PAGE_TITLE, payload)
}

const getFundraisersByUser = async (payload) => {
    return await axios.post(TCF_URL.FUNDRAISERS_BY_USER, payload)
}

const addUpdatesOnFundraiser = async (payload) => {
    return await axios.post(TCF_URL.ADD_UPDATES_ON_FUNDRAISER, payload, fileHeaders)
}

const addSocialCount = async (payload) => {
    return await axios.post(TCF_URL.ADD_SOCIAL_COUNT, payload)
}

const getSocialCount = async (id) => {
    return await axios.get(TCF_URL.GET_SOCIAL_COUNT(id))
}

const getFundraiserUpdates = async (pageId, offset, limit) => {
    return await axios.get(TCF_URL.GET_FUNDRAISER_UPDATES(pageId, offset, limit))
}

const getFundraisersByCampaign = async (eventId, limit, offset) => {
    return await axios.get(TCF_URL.GET_FUNDRASERS_BY_CAMPAIGN(eventId, limit, offset))
}

const getCampaignDetails = async (eventId) => {
    return await axios.get(TCF_URL.GET_CAMPAIGN_DETAILS(eventId))
}

const sendThanksToDonor = async (payload) => {
    return await axios.post(TCF_URL.SEND_THANKS_TO_DONOR, payload)
}

const inviteNewUser = async (payload) => {
    return await axios.post(TCF_URL.INVITE_NEW_USER, payload)
}

const getPageMessages = async (payload) => {
    return await axios.post(TCF_URL.GOOD_LUCK_MESSAGES, payload)
}

export const fundraiserAPIs = {
    getPageMessages,
    inviteNewUser,
    sendThanksToDonor,
    getCampaignDetails,
    getFundraisersByCampaign,
    getFundraiserUpdates,
    getSocialCount,
    getAllFundraisers,
    getFundraiserDetails,
    getEventId,
    getCountryGoalRange,
    createFundraiserPage,
    updateFundraiserPage,
    getCampaignsList,
    getOccasions,
    getFundraiserDefaultImage,
    removeTeamMember,
    getTeamMembers,
    getTeamMembersWithPagination,
    getTeamMembersCount,
    getTeamMemberDetails,
    createTeamMember,
    getPageDonors,
    getPageRecentDonations,
    getPageHighestDonations,
    getPageDonationsCount,
    getFundraisersCount,
    validateFundraiserTitle,
    getFundraisersByUser,
    addUpdatesOnFundraiser,
    addSocialCount
}
